import React from 'react';
import { Box, ThemeProvider } from '@mui/material';
import { Outlet } from 'react-router-dom';
import appTheme from './ui-blocks/AppTheme';
import './App.css';

function App() {
	return (
		<Box id="landing-page" sx={{ display: 'flex', flexDirection: 'column' }}>
			<ThemeProvider theme={appTheme}>
				<Outlet />
			</ThemeProvider>
		</Box>
	);
}

export default App;
